import { NgFor, NgIf, TitleCasePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { RouterLink } from '@angular/router';
import { UtilService } from '../../services/util.service';

@Component({
  selector: 'app-breadcrumb',
  imports: [NgFor, RouterLink, NgIf, TitleCasePipe],
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.css']
})
export class BreadcrumbComponent implements OnInit {
  @Input() breadcrumbs: string[] = [];
  @Input() brands = false
  sanitizedBreadcrumbs: SafeHtml[] = [];

  constructor(private sanitizer: DomSanitizer, private util: UtilService) { }

  ngOnInit(): void {
    this.sanitizedBreadcrumbs = this.breadcrumbs.map((breadcrumb) =>
      this.sanitizer.bypassSecurityTrustHtml(breadcrumb)
    );
  }
  generateBreadcrumbLink(index: number): string {
    let pathSegments = this.breadcrumbs
      .slice(0, index + 1)
      .map((segment) => segment.replace(/\s+/g, '-').toLowerCase());

    let path = pathSegments.join('/');

    if (path.endsWith('-')) {
      path = path.slice(0, -1) + '_';
    }

    const directPaths = ['brands', 'shopping-cart'];
    if (directPaths.includes(path)) {
      return `/${path}`;
    }

    const routeMap: { [key: string]: string } = {
      'privacy-policy': '/privacy',
      'terms-&-conditions': '/terms',
      'return-policy': '/returns-policy',
      'delivery-information': '/delivery',
      'about-us': '/about',
      'log-in': '/login',
      'contact-us': '/contact',
      'location': '/location',
      'forgot-password': '/forgot-password'
    };

    const lastSegment = pathSegments[pathSegments.length - 1];
    if (routeMap[lastSegment]) {
      return routeMap[lastSegment];
    }
    return `/category/${path}`;
  }

  getBreadcrumbLink(index: number): string {
    const url = this.generateBreadcrumbLink(index);
    if (this.brands) {
      return url.replace('/category/brands', '/brand');
    }
    return url;
  }
  getCategoryName(itemName: string) {
    let category: any = this.util.getMenuList(itemName)
    return (category.categoryName || itemName).replace(/-/g, ' ').replace(/_/g, ' ')
  }
}
